<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      outletId: null,
    }
  },
  computed: {},
  watch: {},
  mounted() {
    debugger
    let data = window.localStorage.getItem('auth.authDetails')
    if (data == null || data == 'null') {
      this.$router.push('/login')
    }
    //
    // this.outletId = this.user.outlets[0]
    // if (this.$router.currentRoute.query.outlet !== undefined) {
    //   this.getOLOOutlets(this.$router.currentRoute.query.outlet).then(res1 => {
    //     if (res1.data.length > 0) {
    //
    //       let resdetails = res1.data.find(
    //         x => x.name.toLowerCase() == this.$router.currentRoute.query.outlet
    //       )
    //       if (resdetails.olo.status === true) {
    //         window.localStorage.setItem('selectedOutlet', resdetails._id)
    //         this.$router.push('/orderTypeselection')
    //       }
    //     } else {
    //       this.$router.push('/404')
    //     }
    //   })
    // } else {
    //   this.$router.push({ name: 'OutletSelectionPage' })
    // }
    // this.getOLOEnabledOutlets().then(res => {
    //   if(res.data.length > 0){
    //     window.localStorage.setItem('selectedOutlet', res.data[0])
    //     window.localStorage.setItem('selectedOutlet', res.data[0]._id)
    //     this.$router.push('/orderTypeselection')
    //   }
    // })
  },
  methods: {},
}
</script>

<template>
  <layout>
    <!-- <h1>C4 FITNESS</h1> -->
  </layout>
</template>

<style lang="scss">
.app-body .main {
  //background-image: url('../../assets/images/bodybg2.jpg');
  background-position: center center;
  //background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: contain;
  //background-color: #464646;
  //  margin-left: auto;
  //  margin-right: 5%;
}
</style>
